import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_se88gvsk22: FaireBrandEntity = {
  token: "b_se88gvsk22",
  type: "brand",
  name: "Comfortarians",
  avatarUrl:
    "https://cdn.faire.com/fastly/b86a6812ce022cbb5bfe39c8b54cd370f5a165c51bc43a321f09bb63527425b9.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/e8f04084db6c7d1ab54b3b9fe34f19b28c93270f317327469737208176126287.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/b86a6812ce022cbb5bfe39c8b54cd370f5a165c51bc43a321f09bb63527425b9.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e8f04084db6c7d1ab54b3b9fe34f19b28c93270f317327469737208176126287.jpeg",
  location: "Englewood Cliffs, NJ, USA",
  minimumOrderDollars: 150,
  rating: 4.5,
  reviewCount: 52,
  isInsider: true,
  description:
    "Comfortarian carried all socks made in Korea.  We offer variety of selections from functional socks to daily casual socks.",
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:57:50.639Z",
    importedBy: "entity-db-cli",
  },
};
